import React from "react";
import MuiTextField from "@mui/material/TextField";
import { textFieldProps } from "./fieldProps";

/**
 * `select` (single) — a NATIVE select: the platform's own keyboard and screen-reader behaviour.
 * A multiple select renders as `ChoiceField` checkboxes instead (FieldControl).
 */
export default function SelectField(props) {
	const { field, msg } = props;
	return (
		<MuiTextField {...textFieldProps(props)} select SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
			<option value="">{msg ? msg("widget.select_placeholder", "Choose…") : "Choose…"}</option>
			{(field.options || []).map((o) => (
				<option key={o.value} value={o.value}>{o.label}</option>
			))}
		</MuiTextField>
	);
}
